<script lang="ts" setup>
import { useNavButton } from './composables/useNavButton'
import InvestorSubMenu from '@/domains/investor/components/SubMenu/SubMenu.vue'
import { PARTNERS_SUB_MENU_ITEMS } from '@/domains/partners/const/subMenu.const'

const { locale } = useI18n()
const lang = computed(() => locale.value)
useNavButton()
</script>

<template>
  <Html :lang="lang">
    <Body class="partners-page">
      <UiNavigation :sticking="false" />

      <InvestorSubMenu :items="PARTNERS_SUB_MENU_ITEMS" />

      <main class="main">
        <slot />
      </main>

      <UiFooter />
    </Body>
  </Html>
</template>

<style lang="scss">
.partners-page {
  @include atM {
    .navigation {
      background-color: $white;
      box-shadow: 0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.08);
    }
  }
}
</style>
